import {useUsers} from "@/hooks/User";
import {Card, CardContent, CardHeader, CardTitle} from "@/components/ui/card";
import {Table, TableBody, TableCell, TableHead, TableHeader, TableRow} from "@/components/ui/table";
import {Link} from "react-router-dom";
import React from "react";

function TeamPage() {
    const users = useUsers();
    return (
        <div className="page">
            <TableBody ></TableBody>
            <div className="page-header"><div><h1>Team</h1><p>People directory</p></div></div>
            <Card>
                <CardHeader><CardTitle>People</CardTitle></CardHeader>
                <CardContent>
                    <Table><TableHeader><TableRow><TableHead>Name</TableHead><TableHead>Role</TableHead><TableHead>Title</TableHead><TableHead>Joined</TableHead></TableRow></TableHeader>
                        <TableBody>
                            {users.map(u => (<TableRow key={u.id}><TableCell><Link to={`/team/${u.id}`}>{u.name}</Link></TableCell><TableCell>{u.role}</TableCell><TableCell>{u.job_title || '—'}</TableCell><TableCell>{u.join_date || '—'}</TableCell></TableRow>))}
                        </TableBody>
                    </Table>
                </CardContent>
            </Card>
        </div>
    );
}

export default TeamPage;